<script>
    import Toggle from "svelte-toggle";
    export let view = null;
    if (view == null) {
        console.error('View not passed to navBar!');
    }
    
    $: isExcerptsView = (view == 'bookmarks');

    function toggleView() {
        view = (view == 'bookmarks' ? 'excerpts' : 'bookmarks');
    }
</script>
  
<div id="nav-bar">
    <div id="view-toggle">
        <span class="toggle_label" class:inactive="{!isExcerptsView}">Bookmarks</span> 
        <span class="toggle">
                <Toggle untoggledColor="rgb(102, 179, 209)" toggledColor="rgb(102, 179, 209)" hideLabel toggled={!isExcerptsView} on:toggle={() => toggleView()}/> 
        </span>
        <span class="toggle_label" class:inactive="{isExcerptsView}">Excerpts</span>
    </div>
</div>

<style>
    #nav-bar {
        margin: 1em auto;
        display: flex;
        flex-direction: column;
        color: white;
    }
    #view-toggle {
        margin: auto;
        display: inline-flex;
    }
    .toggle {
        margin: auto 1em;
        color: rgb(102, 179, 209);
    }
    .toggle_label {
        min-width: 7em;
        background-color: rgb(68, 68, 68);
        padding: 0.5em;
        text-align: center;
        border-radius: 7px;
    }
    .inactive {
        opacity: 0.5;
    }
</style>